import { createContext, useCallback, useContext, useState } from 'react';

const SetHeaderHeightContext = createContext();

export const SetHeaderHeightProvider = ({ children }) => {
  const [headerHeight, setHeaderHeight] = useState();

  // set header height click handler
  const setHeaderHeightValue = useCallback(value => {
    setHeaderHeight(value);
  }, []);

  return (
    <SetHeaderHeightContext.Provider
      value={{ headerHeight, setHeaderHeightValue }}
    >
      {children}
    </SetHeaderHeightContext.Provider>
  );
};

export const useSetHeaderHeightContext = () =>
  useContext(SetHeaderHeightContext);
